module.exports = __webpack_public_path__ + "static/Pages-51dc34cd4e90e03ff8836580ff91ce48.jpg";